import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import * as Router from "react-router-dom";
import * as Icons from "react-feather";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { connect } from "react-redux";
import { Stars } from "component/shared/ranking/stars";
import { setLeadsPageFilters } from "redux/slice/leads-page"
import { getLeadsPageFilters, getUserUnsafe } from "redux/selector";
import { hasSearchAgent } from "shared/search-agent-permission";
import { LeadStatus } from "type/lead-status";
import { LeadPipelineType } from "type/lead-pipeline";
import { LeadRanking } from "type/lead-ranking";
import { setAgentValue } from "redux/slice/agents";
import { Agent } from "model/agent";

const mapStateToProps = (state: RootState) => {
	const filters = getLeadsPageFilters(state);
	const selectedAgentId = state.agents.value;
	const searchAgent = hasSearchAgent(getUserUnsafe(state));
	return {
		filters,
		selectedAgentId,
		searchAgent,
	};
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	setLeadsPageFilters,
	setAgentValue
}, dispatch);

interface State { 
}

interface OwnProps {
	emailFilter?: boolean
	agents?: Agent[]
	readOnly?: boolean
}

interface Props extends 
	OwnProps,
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	Router.RouteComponentProps,
	WithStyles<typeof styles>
{
}

class Component extends React.Component<Props, State> {

	private deletable(onDelete: () => void) {
		return this.props.readOnly ? undefined : onDelete;
	}

	public render() {
		const { classes = {}, filters, setLeadsPageFilters, emailFilter, agents, setAgentValue, selectedAgentId, searchAgent } = this.props;
		return (
			<>
				{filters.agent && agents && filters.agent.map((value, index, values) => {
					const agent = agents.filter(agent => agent.id === value)[0];
					if (value === -1) {
						return (
							<Mui.Chip
								key={index}
								label={"Unassigned"}
								onDelete={this.deletable(() => {
									setAgentValue(0)
									setLeadsPageFilters({
										...filters,
										agent: values.filter(item => item !== value),
									});
								})}
								deleteIcon={<Icons.XCircle color="#616161" />}
								className={classes.chip}
							/>
						)
					}
					return (
						<Mui.Chip
							key={index}
							label={agent.name || agent.email}
							onDelete={this.deletable(() => {
								if (value === selectedAgentId) {
									setAgentValue(0)
								}
								setLeadsPageFilters({
									...filters,
									agent: values.filter(item => item !== value),
								});
							})}
							deleteIcon={<Icons.XCircle color="#616161" />}
							className={classes.chip}
						/>
				)
				})}
				{filters.type && filters.type.map((value, index, values) => (
					<Mui.Chip
						key={index}
						label={value}
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								type: values.filter(item => item !== value),
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				))}
				{filters.status && filters.status.filter((value) => {
					if (emailFilter) {
						return value === LeadStatus.ACTIVE.id
					} 
					return true;
				}).map((value, index, values) => {
					const statusType = LeadStatus.getById(value);
					if (!statusType) {
						return null;
					}
					return (
						<Mui.Chip
							key={index}
							label={statusType.label}
							onDelete={this.deletable(() => {
								setLeadsPageFilters({
									...filters,
									status: values.filter(item => item !== value),
								});
							})}
							deleteIcon={<Icons.XCircle color="#616161" />}
							className={classes.chip}
						/>
					);
				})}
				{filters.bookmarked && 
					<Mui.Chip
						label="Bookmarked"
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								bookmarked: false,
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				}
				{filters.subscribed && 
					<Mui.Chip
						label="Receives Email Updates"
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								subscribed: false,
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				}
				{searchAgent && filters.searchAgent &&
					<Mui.Chip
						label="Search Agent Leads"
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								searchAgent: false,
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				}
				{filters.ranking && filters.ranking.map((value, index, values) => {
					const leadRanking = LeadRanking.getById(value);
					if (!leadRanking) {
						return null;
					}
					return (
						<Mui.Chip
							key={index}
							label={<Stars leadRanking={leadRanking} />}
							onDelete={this.deletable(() => {
								setLeadsPageFilters({
									...filters,
									ranking: values.filter((item) => item !== value),
								});
							})}
							deleteIcon={<Icons.XCircle color="#616161" />}
							className={classes.chip}
						/>
					);
						})}
				{filters.source && filters.source.map((value, index, values) => (
					<Mui.Chip
						key={index}
						label={value}
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								source: values.filter(item => item !== value),
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				))}
				{filters.pipeline && filters.pipeline.map((value, index, values) => {
					const leadPipelineType = LeadPipelineType.getById(value);
					if (!leadPipelineType) {
						return null;
					}
					return (
						<Mui.Chip
							key={index}
							label={leadPipelineType.label}
							onDelete={this.deletable(() => {
								setLeadsPageFilters({
									...filters,
									pipeline: values.filter(item => item !== value),
								});
							})}
							deleteIcon={<Icons.XCircle color="#616161" />}
							className={classes.chip}
						/>
					);
				})}
				{filters.tag && filters.tag.map((value, index, values) => (
					<Mui.Chip
						key={index}
						label={`TAG: ${value}`}
						onDelete={this.deletable(() => {
							setLeadsPageFilters({
								...filters,
								tag: values.filter(item => item !== value),
							});
						})}
						deleteIcon={<Icons.XCircle color="#616161" />}
						className={classes.chip}
					/>
				))}
			</>
		);
	}

}



export const FiltersChips = withStyles(Router.withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Component)
), styles);